export const ERRORS = {
  NEED_REDIRECT: 'NEED_REDIRECT',
};

// Закодированные строки 'date', 'headers' для получения значения date их хедеров запроса для антипарсера
// https://onetwotripdev.atlassian.net/wiki/spaces/AVIA/pages/2359721996
export const DATE_SLUG_ENCODED = '0d081d0c';
export const HEADERS_SLUG_ENCODED = '010c080d0c1b1a';
export const CACHE_CONTROL_VERSION_SLUG_ENCODED = '2a080a010c442a06071d1b0605443f0c1b1a000607';
export const HEADER_KEY = 'X-OTT-Cookie';
export const SEPARATOR = '###';
export const RECAPTCHA_KEY = '6LePmCITAAAAAOMx5rQ7P-Ycs6rygGMBFxyxYLSS';
export const CONTAINER_PREFIX = 'captcha-mount-';
